// 全部用户
import {queryCoreAccountSearch} from '@api/core/user';

// 按模块的action, reducer整合体
const CORE_ACCOUNT_SEARCH = 'CORE_ACCOUNT_SEARCH';

export function getAccountSearch() {
  return (dispatch, getState) => {
    const { core_account_search: search } = getState();
    if (search.length > 0) {
      return dispatch({
        type: CORE_ACCOUNT_SEARCH,
        data: search,
      });
    }
    return queryCoreAccountSearch().then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: CORE_ACCOUNT_SEARCH,
          data: res.data,
        });
      }
    });
  };
}

export function coreAccountSearch(state = [], action) {
  switch (action.type) {
    case CORE_ACCOUNT_SEARCH:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/core_account_search.js